/**
 * Green Flag — Badge recipe
 *
 * Small inline pills:
 *   - sparks    → green-tint "3 Sparks Attending" chip (forest-ink text)
 *   - notify    → red circular notification dot (has number inside)
 *   - count     → friends-blue avatar badge (used on photo corners)
 *
 * For tab chips, see `TabsRecipe.ts` instead.
 */

import { defineRecipe } from "@chakra-ui/react";

export const badgeRecipe = defineRecipe({
  className: "gf-badge",

  base: {
    display: "inline-flex",
    alignItems: "center",
    gap: "1",
    fontFamily: "body",
    lineHeight: "tight",
  },

  variants: {
    visual: {
      sparks: {
        bg: "bg.brandTint",
        color: "fg.onTint",
        borderRadius: "xs",
        px: "3",
        py: "1",
        fontWeight: "bold",
        fontSize: "2xs",
      },
      friendsChip: {
        bg: "bg.friends",
        color: "fg.onBrand",
        borderRadius: "xs",
        px: "3",
        py: "1",
        fontWeight: "bold",
        fontSize: "2xs",
      },
      sparksLarge: {
        bg: "bg.brandTint",
        color: "fg.onTint",
        borderRadius: "xs",
        px: "3",
        py: "2",
        fontWeight: "bold",
        fontSize: "md",
      },
      notify: {
        bg: "bg.danger",
        color: "fg.onBrand",
        borderRadius: "full",
        minW: "15px",
        h: "15px",
        px: "1",
        fontWeight: "bold",
        fontSize: "xs",
        justifyContent: "center",
      },
      mode: {
        bg: "bg.brand",
        color: "fg.onBrand",
        borderRadius: "full",
        w: "22px",
        h: "22px",
        justifyContent: "center",
      },
      modeFriends: {
        bg: "bg.friends",
        color: "fg.onBrand",
        borderRadius: "full",
        w: "22px",
        h: "22px",
        justifyContent: "center",
      },
    },
  },

  defaultVariants: {
    visual: "sparks",
  },
});
